import * as actions from './actions';
import messages from './messages';

const initState = { showModal: false,
    uploadSummary: {
        validationErrors: [],
        newStudents: [],
        updatedStudents: [],
        unassignedStudents: [],
        newTeachers: [],
        updatedTeachers: [],
        unassignedTeachers: [],
        newClassrooms: [],
        updatedClassrooms: []
    } };
const message = { header: {}, body: '' };

export default function (state = initState, action) {
    switch (action.type) {
    case actions.DOWNLOAD_QUICK_UPLOAD_TEMPLATE_REQUEST: {
        return {
            ...state,
            downloadingQuickUploadTemplate: action.downloadingQuickUploadTemplate,
            showModal: initState.showModal
        };
    }
    case actions.DOWNLOAD_QUICK_UPLOAD_TEMPLATE_SUCCESS: {
        return { ...state, downloadingQuickUploadTemplate: action.downloadingQuickUploadTemplate };
    }
    case actions.QUICK_UPLOAD_TEMPLATE_REQUEST: {
        return { ...state, uploadingTemplate: action.uploadingTemplate };
    }
    case actions.QUICK_UPLOAD_TEMPLATE_SUCCESS: {
        return {
            ...state,
            showModal: action.showModal,
            uploadingTemplate: action.uploadingTemplate,
            uploadSummary: action.quickUploadResponse,
            message: { header: messages.quickUploadSuccessMessage, body: '' },
            componentType: 'confirmation'
        };
    }
    case actions.QUICK_UPLOAD_TEMPLATE_FAILURE: {
        if (action.isServerError) {
            message.header = messages.errorMessageHeader;
            message.body = messages.errorMessageBody.defaultMessage;
        } else {
            message.header = action.isWarning ? '' : messages.validationMessage;
            message.body = action.errorMessage.indexOf('Rollover') !== -1 ?
                action.errorMessage.split('Rollover')[1] : action.errorMessage;
        }
        return {
            ...state,
            showModal: action.showModal,
            uploadingTemplate: action.uploadingTemplate,
            message,
            componentType: action.isWarning ? 'warning' : 'validation'
        };
    }
    case actions.QUICK_UPLOAD_CLOSE_MODAL_REQUEST: {
        return { ...state, showModal: action.showModal };
    }
    default:
        return { ...state };
    }
}



// WEBPACK FOOTER //
// ./app/containers/quick-upload/reducer.js